import { StepperData } from "@/components/molecules/Progress/FlowSteps/FlowSteps";
import { fakeI18n } from "@/i18n";

export enum ResetPasswordSteps {
    CONFIRM_EMAIL = "confirm_email",
    EMAIL_SENT = "email_sent",
    NEW_PASSWORD = "new_password",
    PASSWORD_UPDATED = "password_updated",
}

export const stepperData: StepperData[] = [
    {
        key: ResetPasswordSteps.CONFIRM_EMAIL,
        label: fakeI18n.t("Common.ConfirmEmail"),
    },
    {
        key: ResetPasswordSteps.EMAIL_SENT,
        label: fakeI18n.t("ResetPassword.EmailSent.EmailSent"),
    },
    {
        key: ResetPasswordSteps.NEW_PASSWORD,
        label: fakeI18n.t("ResetPassword.NewPassword.NewPassword"),
    },
    {
        key: ResetPasswordSteps.PASSWORD_UPDATED,
        label: fakeI18n.t("ResetPassword.PasswordUpdated.PasswordUpdated"),
    },
];
